import { ImageViewer } from './ImageViewer'
import { withImageViewer } from './withImageViewer'

const ConnectedImageViewer = withImageViewer(ImageViewer)
export { ConnectedImageViewer as ImageViewer }
